const formatToCurrency = (value: number) => {
  return process.browser
    ? new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(value)
    : value;
};
export default formatToCurrency;
